import templateUrl from "emun.cart/cart-item-quick-view-image.htm";

export default () => ({
  templateUrl
});
